import axios from 'axios';

const API_URL = process.env.REACT_APP_API;

export interface TicketRemanente {
  folio_ticket: string;
  cliente: string;
  evento: string;
  total_cargado: number;
  total_cortesia: number;
  total_recarga_caja: number;
  total_consumido: number;
  saldo_remanente: number;
  fecha_creacion: string;
}

export async function getReporteRemanente(ids_dia: number[]): Promise<TicketRemanente[]> {
  try {
    const response = await axios.get(`${API_URL}cortesias/reporte-remanente`, {
      params: { ids_dia: ids_dia.join(',') },
    });
    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error fetching reporte remanente:', error);
    throw error;
  }
}
